const registerCheckboxEl = document.getElementById("frm-customerForm-register");
const passwordWrapEl = document.getElementById("passwordWrap");

if (registerCheckboxEl) {
	registerCheckboxEl.addEventListener("click", ev => {
		passwordWrapEl.classList.toggle("d-none");
	});
}
